import(/* webpackMode: "eager" */ "/app/src/components/client/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/client/Section/Section.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingBlog"] */ "/app/src/features/client/Blog/HeadingBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaginationBlock"] */ "/app/src/features/client/Blog/PaginationBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainSection"] */ "/app/src/features/client/MainSection/MainSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainSectionLayout"] */ "/app/src/features/client/MainSectionLayout/MainSectionLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentWrapper"] */ "/app/src/views/client/BlogsPage/ContentWrapper.tsx");
